import { createContext } from "react";

export interface IExerciseLibraryDrawerProps {
  exerciseLibraryDrawerOpen: boolean;
  setExerciseLibraryDrawerOpen: (data: boolean) => void;
}

const ExerciseLibraryDrawerContext = createContext<
  IExerciseLibraryDrawerProps | undefined
>(undefined);

export default ExerciseLibraryDrawerContext;
